import React from "react";
import Question from "./pages/question";
import HeaderPage from "./pages/header-page";

function AppQuestion() {
    return (
        <>
            <HeaderPage />
            <Question />
        </>
    );
}

export default AppQuestion;